import React from "react";
import {
  Box,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import { COMPANY_USER_ROLE_LABEL } from "./companyUserUtils";

// 2つ並びの入力フィールド用のスタイル
const twoFieldGridSx = {
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)",
  gap: 1,
  minWidth: 0,
};

// 共通テキストフィールド
function CompanyUserTextField({ label, value, onChange, error = false }) {
  return (
    <TextField
      fullWidth
      size="small"
      label={label}
      value={value ?? ""}
      onChange={onChange}
      error={error}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      sx={{
        minWidth: 0,
        "& .MuiOutlinedInput-root": {
          backgroundColor: "#fff",
        },
        "& .MuiOutlinedInput-root input": {
          border: "none",
          boxShadow: "none",
          minWidth: 0,
        },
      }}
    />
  );
}

// 2つ並びの共通入力フィールド
function CompanyUserPairFields({ left, right }) {
  return (
    <Box sx={{ minWidth: 0 }}>
      <Box sx={twoFieldGridSx}>
        <CompanyUserTextField {...left} />
        <CompanyUserTextField {...right} />
      </Box>
    </Box>
  );
}

// 担当者入力フィールドの設定を作成
function buildUserField(companyUser, localErrors, onFieldChange, label, field) {
  return {
    label,
    value: companyUser[field],
    onChange: (e) => onFieldChange(companyUser.id, field, e.target.value),
    error: !!localErrors.users?.[companyUser.id]?.[field],
  };
}

/**
 * 担当者一覧の1行分
 *
 * 表示だけを担当し、state は親から受け取る
 */
export default function CompanyUserRow({
  companyId,
  companyUser,
  localErrors,
  visibleCompanyUsersLength,
  onFieldChange,
  onRoleChange,
  onDeleteClick,
}) {
  return (
    <>
      <CompanyUserPairFields
        left={buildUserField(
          companyUser,
          localErrors,
          onFieldChange,
          "姓",
          "last_name",
        )}
        right={buildUserField(
          companyUser,
          localErrors,
          onFieldChange,
          "名",
          "first_name",
        )}
      />

      <CompanyUserPairFields
        left={buildUserField(
          companyUser,
          localErrors,
          onFieldChange,
          "セイ",
          "last_name_kana",
        )}
        right={buildUserField(
          companyUser,
          localErrors,
          onFieldChange,
          "メイ",
          "first_name_kana",
        )}
      />

      <Box sx={{ minWidth: 0 }}>
        <CompanyUserTextField
          label="メールアドレス"
          value={companyUser.email}
          onChange={(e) =>
            onFieldChange(companyUser.id, "email", e.target.value)
          }
          error={!!localErrors.users?.[companyUser.id]?.email}
        />
      </Box>

      <Box sx={{ minWidth: 0 }}>
        <Box
          sx={{
            display: "flex",
            gap: 1,
            alignItems: "center",
            minWidth: 0,
          }}
        >
          <FormControl
            fullWidth
            size="small"
            error={!!localErrors.role}
            sx={{
              minWidth: 0,
              "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "#d32f2f",
                },
            }}
          >
            <InputLabel
              id={`company-user-role-label-${companyId}-${companyUser.id}`}
            >
              役割
            </InputLabel>

            <Select
              labelId={`company-user-role-label-${companyId}-${companyUser.id}`}
              value={companyUser.role ?? ""}
              label="役割"
              onChange={(e) => onRoleChange(companyUser.id, e.target.value)}
              onClick={(e) => e.stopPropagation()}
              onMouseDown={(e) => e.stopPropagation()}
              sx={{
                minWidth: 0,
                backgroundColor: "#fff",
              }}
            >
              <MenuItem value="admin">{COMPANY_USER_ROLE_LABEL.admin}</MenuItem>
              <MenuItem value="general">
                {COMPANY_USER_ROLE_LABEL.general}
              </MenuItem>
            </Select>
          </FormControl>

          <IconButton
            color="error"
            onClick={(e) => {
              e.stopPropagation();
              onDeleteClick(companyUser.id);
            }}
            disabled={visibleCompanyUsersLength === 1}
            size="small"
            sx={{ flexShrink: 0 }}
          >
            <Delete />
          </IconButton>
        </Box>
      </Box>
    </>
  );
}
